import { LanguageCode } from '@sparted/shared-library/business/types';
import i18next from 'i18next';
import m from 'mithril';

export const inferInitialSelectedLanguage = (languages: LanguageCode[], resetUrlParams = false): LanguageCode => {
  const currentBoLanguage = i18next.language as LanguageCode;
  const languageParam = m.route.param('language') as LanguageCode;

  if (!resetUrlParams) {
    const url = window.location.href;
    window.history.replaceState(null, '', url.split('?')[0]);
  }
  if (languages.includes(languageParam)) {
    return languageParam;
  }

  if (languages.includes(currentBoLanguage)) {
    return currentBoLanguage;
  }

  return languages[0];
};
